import Revenue from "../../Revenue/index";
import CalculatedDriver_Values from "../../CalculatedDriver/CalculatedDriver_Values";
import FinanceGeneric from "../../FinanceGeneric";
import datastructure from "../../../datastructure.json";
import TradingMultiples from "../TradingMultiples";
import { UnitTypes } from "../../CalculatedDriver/constants";

class TransactionMultiples extends FinanceGeneric {
  CompanyName = "";
  Country = "";
  CompanyDescription = "";
  Note = "";
  IncludeInValuation = true;
  IsTmpData = false;

  constructor(db_record) {
    super(db_record);
    if (this.db_record) {
      this.CompanyName = this.db_record.CompanyName;
      this.Country = this.db_record.Country;
      this.CompanyDescription = this.db_record.CompanyDescription;
      this.Note = this.db_record.Note;
      this.IsTmpData = false;
      this.IncludeInValuation = this.db_record.IncludeInValuation;
      this.setDriversFromDataStorageSub();
    }
    this.SaveRevenue = this.Save;
    this.Save = this.SaveTradingMultiples;
  }

  SaveNew = (callBack) => {
    global.Modeliks.post(this.constructor.TableName, this, (res) => {
      this.ID = res.id;
      this.createDriverValues(this.ID);
      this.Save(() => callBack(this));
    });
  };

  static createNewTransactionsMultiples = (callBack) => {
    const newTradingMultiples = new TransactionMultiples();
    newTradingMultiples.CompanyName = "CompanyName";
    newTradingMultiples.Country = "Country";
    newTradingMultiples.CompanyDescription = "CompanyDescription";
    newTradingMultiples.Note = "Note";
    newTradingMultiples.SaveNew(callBack);
  };

  static getTransactionsMultiples = (callBack) => {
    if (!global.Modeliks.TransactionsMultiplesStore.length > 0) {
      TransactionMultiples.createNewTransactionsMultiples((newRec) => {
        callBack();
      });
    } else {
      return global.Modeliks.TransactionsMultiplesStore.filter((t) => t.IsTmpData === false);
    }
  };
  static DriverValuesDesc = Object.assign({
    Revenue: {
      fieldName: "Revenue",
      driverID: "trsm_revenue",
      unit: UnitTypes.Price,
    },
    RevenueGrowth: {
      fieldName: "RevenueGrowth",
      driverID: "trsm_revenue_growth",
      unit: UnitTypes.Percentage,
    },
    EBITDA: {
      fieldName: "EBITDA",
      driverID: "trsm_ebitda",
      unit: UnitTypes.Price,
    },
    EBITDAMargin: {
      fieldName: "EBITDAMargin",
      driverID: "trsm_ebitda_margin",
      unit: UnitTypes.Percentage,
    },
    NetProfit: {
      fieldName: "NetProfit",
      driverID: "trsm_net_profit",
      unit: UnitTypes.Price,
    },
    NetProfitMargin: {
      fieldName: "NetProfitMargin",
      driverID: "trsm_net_profit_margin",
      unit: UnitTypes.Percentage,
    },
    RevenueMultiple: {
      fieldName: "RevenueMultiple",
      driverID: "trsm_revenue_multiple",
      unit: UnitTypes.Multiple,
    },
    EBITDAMultiple: {
      fieldName: "EBITDAMultiple",
      driverID: "trsm_ebitda_multiple",
      unit: UnitTypes.Multiple,
    },
    PEMultiple: {
      fieldName: "PEMultiple",
      driverID: "trsm_pe_multiple",
      unit: UnitTypes.Multiple,
    },
  });

  static TableName = datastructure.Valuation_Transactions_Multiples.TableName;

  createDriverValues = (driverID = null) => {
    Object.values(this.constructor.DriverValuesDesc).forEach((driverVal) => {
      if (this.hasOwnProperty(driverVal.fieldName) == false) {
        this[driverVal.fieldName] = new CalculatedDriver_Values(
          null,
          driverID
            ? `${TransactionMultiples.TableName}-${driverID}-${driverVal.driverID}`
            : driverVal.driverID,
          null,
          driverVal.unit,
        );
      }
    });
  };

  SaveTradingMultiples = (callBack, saveDrivers = true, saveValues = true) => {
    global.Modeliks.put(this.constructor.TableName, null, this, (res) => {
      global.Modeliks.post(
        global.Modeliks.Tables.Finance_CalculatedDriver_Values.TableName,
        Object.values(this.constructor.DriverValuesDesc).map(
          (driverVal) => this[driverVal.fieldName].cur_record,
        ),
        (res) => {
          callBack();
        },
      );
    });
  };

  getTransactionMultiplesID = (valID) => {
    return `${TransactionMultiples.TableName}-${this.ID}-${valID}`;
  };

  setDriversFromDataStorageSub = () => {
    Object.values(this.constructor.DriverValuesDesc).forEach((driverVal) => {
      if (!this.hasOwnProperty(driverVal.fieldName)) {
        const findVal = global.Modeliks.DriverValuesStore.getItem(
          this.getTransactionMultiplesID(driverVal.driverID),
        );
        if (findVal) {
          this[driverVal.fieldName] = findVal;
        }
      }
    });
  };

  static tmpTypes = Object.assign({
    Median: {
      fieldName: "Median",
      driverID: "trm_median_tmp",
    },
    Average: {
      fieldName: "Average",
      driverID: "trm_average_tmp",
    },
    Minimum: {
      fieldName: "Minimum",
      driverID: "trm_minimum_tmp",
    },
    Maximum: {
      fieldName: "Maximum",
      driverID: "trm_maximum_tmp",
    },
  });

  createTmpFormulas = (driverValues, type = null) => {
    const hasDriverValues = driverValues.length > 0;
    Object.values(TransactionMultiples.DriverValuesDesc).forEach((driverVal) => {
      const curDriverValues = driverValues.map((d) => d[driverVal.fieldName]).join(",");
      switch (type) {
        case TransactionMultiples.tmpTypes.Minimum.driverID:
          this[driverVal.fieldName].Formula = hasDriverValues
            ? `MxMath.MinOfArr(${curDriverValues})`
            : null;
          break;
        case TransactionMultiples.tmpTypes.Maximum.driverID:
          this[driverVal.fieldName].Formula = hasDriverValues
            ? `MxMath.MaxOfArr(${curDriverValues})`
            : null;
          break;
        case TransactionMultiples.tmpTypes.Median.driverID:
          this[driverVal.fieldName].Formula = hasDriverValues
            ? `MxMath.Median(${curDriverValues})`
            : null;
          break;
        default:
          this[driverVal.fieldName].Formula = hasDriverValues
            ? `MxMath.Average([${curDriverValues}])`
            : null;
      }
      if (driverVal.unit === UnitTypes.Percentage && hasDriverValues) {
        this[driverVal.fieldName].Formula = `(${this[driverVal.fieldName].Formula}) * 100`;
      }
    });
  };

  static tmpTotalsTransactionMultiples = (callBack) => {
    const driverValues = global.Modeliks.TransactionsMultiplesStore.filter(
      (d) => d.IsTmpData === false && d.IncludeInValuation === true,
    );
    callBack(
      Object.values(TransactionMultiples.tmpTypes).map((driverVal) => {
        let tmpTradingMultiple = global.Modeliks.TransactionsMultiplesStore.find(
          (d) => d.ID === driverVal.driverID,
        );
        if (!tmpTradingMultiple) {
          const newTMP = new TransactionMultiples();
          newTMP.createDriverValues(driverVal.driverID);
          newTMP.createTmpFormulas(driverValues, driverVal.driverID);
          newTMP.ID = driverVal.driverID;
          newTMP.IsTmpData = true;
          newTMP.CompanyName = driverVal.fieldName;
          newTMP.CompanyDescription = "software/hardware";
          newTMP.Note = "comments";
          global.Modeliks.TransactionsMultiplesStore.push(newTMP);
          return newTMP;
        }

        tmpTradingMultiple.createTmpFormulas(driverValues, driverVal.driverID);
        return tmpTradingMultiple;
      }),
    );
  };
}

export default TransactionMultiples;
